module.exports = __webpack_public_path__ + "img/video.3cbeae54.svg";